import { isAfter } from "date-fns";
import { useRouter } from "next/compat/router";
import { useMemo } from "react";
import useToday from "~/core/useToday";
import StayRequest from "./StayRequest";

export const useOptionalStayRequest = (): StayRequest | undefined => {
  const router = useRouter();
  const today = useToday();

  const stayRequest = useMemo(() => {
    if (!router?.query.checkIn || !router?.query.checkOut) {
      return undefined;
    }

    return StayRequest.fromQueryString(router.query, today);
  }, [router?.query, today]);

  return stayRequest;
};

const computeStayRequestCheckInDate = (
  firstBookableDate: Date | undefined,
): Date => {
  const today = new Date();

  if (firstBookableDate) {
    return isAfter(today, firstBookableDate) ? today : firstBookableDate;
  }

  return today;
};

const useStayRequest = ({
  firstBookableDate,
}: {
  firstBookableDate: Date | undefined;
}): StayRequest => {
  const router = useRouter();

  const stayRequest = useMemo(() => {
    if (!router) {
      return StayRequest.forTonight(new Date(), 1, 0, 0);
    }

    return StayRequest.fromQueryString(
      router.query,
      computeStayRequestCheckInDate(firstBookableDate),
    );
  }, [router, firstBookableDate]);

  return stayRequest;
};

export default useStayRequest;
